import React from 'react'
import Collapsible from 'react-collapsible'
import './Accordion.sass'

const Accordion = ({ trigger, children, open, onChange, ...props }) => {
  return (
    <Collapsible
      trigger={trigger}
      transitionTime={500}
      easing={'ease'}
      open={open}
      onOpening={() => onChange(true)}
      onClosing={() => onChange(false)}
      {...props}
    >
      {children}
    </Collapsible>
  )
}

export default Accordion

Accordion.defaultProps = {
  onChange: () => {},
}
